// Auto-generated cornerstone translation for et.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:20:31.081977+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Hobusehalduse rakendus: parim valik 2026 | EquiSight",
      description: "Võrdle hobusehalduse rakendusi omanikule, tallile ja aretusfarmile. Avasta, miks EquiSight on täielik rakendus sinu hobuse jaoks.",
      keywords: [
        "hobusehalduse rakendus",
        "tallihaldustarkvara",
        "hobuste logiraamat rakendus",
        "rakendus mitme hobuse haldamiseks",
        "mära tiinuse rakendus",
        "aretustarkvara hobustele",
        "parim hobusehalduse rakendus",
      ],
    },
    hero: {
      eyebrow: "Valikujuhend · hobusehalduse tarkvara",
      breadcrumbLabel: "Hobusehalduse rakendus",
      title: "Hobusehalduse rakendus: täielik valikujuhend omanikele, tallidele ja aretusfarmidele.",
      intro: "Mitte lihtsalt funktsioonide loend — aus võrdlus, valikujuhend ja ülevaade sellest, mida hobusehalduse rakendus 2026. aastal päriselt suutma peab. Ühe hobuse jaoks, terve talli jaoks või sinu aretusfarmile.",
      pills: [
        {
          icon: "Users",
          label: "Omanikele",
        },
        {
          icon: "Building2",
          label: "Tallidele",
        },
        {
          icon: "Baby",
          label: "Aretusfarmidele",
        },
        {
          icon: "Share2",
          label: "Meeskondadele",
        },
      ],
      ctas: [
        {
          label: "Alusta tasuta 1 hobusega",
          href: "#start",
          primary: true,
        },
        {
          label: "Võrdlustabelisse",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miks hobusehalduse rakendus muutub üha olulisemaks.",
      lead: "Hobusehaldus on praktikas killustunud: WhatsApp, kalender, Excel, fotod telefonis, paberpassport, üksikud arved ja suulised kokkulepped. Ühe hobuse puhul juba ebamugav. Mitme hobuse, aretusfarmide või jagatud hoolduse korral tekivad lüngad, vahelejäänud kohtumised ja vaidlused.",
      items: [
        "Kus see vaktsineerimiskuupäev nüüd oli?",
        "Kes maksis hobusesepa eest?",
        "Millist märat täna kontrollida?",
        "Kas treener luges eelmise nädala juhised läbi?",
        "Kas ma tõesti selle fotodokumendi salvestasin?",
        "Kas tallis rippuv söötmiskava on veel ajakohane?",
      ],
    },
    what: {
      title: "Mis on hobusehalduse rakendus?",
      lead: "Hobusehalduse rakendus on sisuliselt digitaalne toimik iga hobuse kohta. Mitte killustunud märkmed, vaid üks koht tervise, treeningu, toitumise, dokumentide, planeerimise, meeldetuletuste, kulude, fotode, videote ja jagatud juurdepääsu jaoks. Kõik hobuse ümber olevad inimesed vaatavad sama, ajakohast teavet.",
      targetGroupsTitle: "Kellele on hobusehalduse rakendus mõeldud?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Eraisikust omanik",
          body: "Üks hobune, üks toimik — tervis, planeerimine ja ajalugu taskus.",
        },
        {
          icon: "Users",
          title: "Mitme hobuse omanik",
          body: "Eraldi profiilid, eraldi planeerimine, jagatud ülesandeloend kogu meeskonnale.",
        },
        {
          icon: "Building2",
          title: "Pensionitall ja maneež",
          body: "Omaniku juurdepääs, hooldusjuhised, jagatud kalender ja ülesanded.",
        },
        {
          icon: "Baby",
          title: "Aretusefarm",
          body: "Mära tsükkel, tiinus, täkuandmed, sugupuu ja varsa areng.",
        },
        {
          icon: "Target",
          title: "Treenerid",
          body: "Ülevaade hobuse kaupa, seansside logimine, eesmärkide seadmine, videote analüüsimine.",
        },
        {
          icon: "ClipboardList",
          title: "Spetsialistid",
          body: "Hobusesepp, hambaarst, füsioterapeut või veterinaararst — kõik töötavad sama toimiku põhjal.",
        },
      ],
    },
    criteria: {
      title: "Millele peab hea hobusehalduse rakendus vastama?",
      lead: "Rakendus ei pea olema ainult ilus — see peab igapäevaselt praktiliselt toimima. Viis elementi, mis 2026. aasta valikust ei tohi puududa.",
      items: [
        {
          icon: "FileText",
          title: "Hobuse toimik iga hobuse kohta",
          body: "Andmed, vanus, tõug, passiinfo, omanik, tall, fotod ja dokumendid — kõik seotud ühe hobuse profiiliga.",
        },
        {
          icon: "Heart",
          title: "Tervis ja hooldus",
          body: "Vaktsineerimised, ussi­ravimid, hobusesepp, hambaarst, veterinaararst, ravimid, medikamendid ja automaatsed meeldetuletused enne tähtaega.",
        },
        {
          icon: "Activity",
          title: "Treening ja areng",
          body: "Treeningute logimine, märkmed, videod, võistlustulemused, eesmärgid ja areng distsipliini või hobuse kaupa.",
        },
        {
          icon: "Apple",
          title: "Toitumine ja haldus",
          body: "Söötmiskavad, lisandid, jäme­söödad, kaal, keha­konditsiooni­skoor ja igapäevane rutiin, mida tall peab teadma.",
        },
        {
          icon: "Share2",
          title: "Jagamine teistega",
          body: "Juurdepääs omanikule, hooldajale, treenerile, talliomanikule või spetsialistile — õiguste haldamisega, mis sobib igaühe rolliga.",
        },
        {
          icon: "Calendar",
          title: "Planeerimine ja meeldetuletused",
          body: "Jagatud kalender ülesannete, automaatsete meeldetuletuste ja kinnitustega, et mitte midagi ei libiseks vahele.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs teised hobusehalduse rakendused.",
      lead: "Hetkel täidavad turgu Stalmanager, LogMyHorse, EquineM ja Happie Horse. Igaühel on oma tugevused. Seame kõige sagedamini küsitud funktsioonid kõrvuti — ausalt ja avalikult kättesaadava teabe põhjal.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Tasuta alustamine",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Mitu hobust",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Tervise toimik",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Treening ja areng",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Toitumine ja lisandid",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planeerimine ja meeldetuletused",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumendid hobuse kohta",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Jagamine meeskonna ja õigustega",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Aretusemoodul (täielik)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mära tsükkel",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tiinusplaneerimine + ehhod",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Varsa areng",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Spetsialistide integreerimine",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach ülevaated",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sobib omanikule",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Sobib aretusefarmile",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sobib tallile/maneežile",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Võrdlus põhineb jaanuaris 2026 avalikult kättesaadavatel funktsioonidel. Konkurendid on samuti head tööriistad; EquiSight on ehitatud kõiki mooduleid ühes rakenduses ühendama.",
    },
    why: {
      title: "Miks EquiSight on teistsugune.",
      lead: "Logiraamat registreerib. EquiSight ühendab hobusehalduse, treeningu, toitumise, tervise, võistlused, spetsialistid ja aretuse ühes kaasaegses rakenduses — ning astub sammu kaugemale ülevaadete pakkumisega.",
      points: [
        {
          icon: "Heart",
          title: "Üks rakendus kogu hobuse eluks",
          body: "Varsast sporthobuseniks, aretusmäraks või pensionile läinud hobuseks. Toimik kasvab koos sinu hobusega — miski ei lähe teel kaduma.",
        },
        {
          icon: "Sparkles",
          title: "Mitte ainult andmed, vaid ka mustrid",
          body: "EquiCoach ühendab arengu, korduvad kaebused, treeningu ja toitumise — nii näed signaale õigeaegselt, mitte üksikute teadetena.",
        },
        {
          icon: "Share2",
          title: "Ehitatud koostööks",
          body: "Omanik, talliomanik, treener, hobusesepp ja teised spetsialistid töötavad sama hobuse toimiku põhjal — õigustega, mis vastavad nende rollile.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niš · aretusefarm",
      title: "Hobusehaldus aretusfarmidele.",
      lead: "Paljud konkurendid mainivad aretustegevust ühe lausega. EquiSight ehitas täieliku aretusemooduli — sest aretaja on harva üldise rakenduse lõppkasutaja, kuid vajab planeerimist rohkem kui keegi teine.",
      items: [
        "Mära tsükli igapäevane jälgimine",
        "Seemendamise kuupäev + täkuandmed",
        "Tiinuse kontroll ehhode abil",
        "Eeldatav varsumiskuupäev + hoiatused",
        "Varsa areng kuude kaupa",
        "Sugupuu ja päritolu",
        "Märkmed iga mära kohta",
        "Kõigi tiinete märade ülevaade",
      ],
      ctaLabel: "Vaata aretusemoodulit",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niš · tall ja maneež",
      title: "Hobusehaldus mitme hobuse ja pensionitallide jaoks.",
      lead: "Mitme hobuse korral on kesksem roll kommunikatsioonil, mitte niivõrd andmetel. Igal omanikul on oma soovid, rutiinid, söötmiskokkulepped ja meditsiinilised tähelepanekud. Iga töötaja peab saama sellele ligi ilma otsimata.",
      cards: [
        {
          t: "Hobused omaniku kaupa",
          d: "Iga omanik näeb ainult oma hobust/hobuseid.",
        },
        {
          t: "Hooldusjuhised",
          d: "Nähtav iga hobuse kohta tallile.",
        },
        {
          t: "Jagatud kalender",
          d: "Hobusesepp, veterinaararst ja võistlused ühes vaates.",
        },
        {
          t: "Ülesandeloend",
          d: "Töötajatele määramine koos kinnitusega.",
        },
        {
          t: "Omaniku juurdepääs",
          d: "Kliendid näevad oma hobust omas rakenduses.",
        },
        {
          t: "Hädakontaktid",
          d: "Alati leitavad stressirohketes olukordades tallis.",
        },
      ],
      ctaLabel: "Vaata maneežimoodulit",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "WhatsAppist, Excelist ja tahvlilt EquiSight'i.",
      lead: "Konkreetselt: nii muutub sinu igapäevane hobusehaldus.",
      rows: [
        {
          before: "WhatsAppi grupid",
          after: "Struktureeritud märkmed iga hobuse kohta",
        },
        {
          before: "Exceli tabelid",
          after: "Reaalajas hobuse toimik ajalooga",
        },
        {
          before: "Tahvel tallis",
          after: "Jagatud planeerimine sinu telefonis",
        },
        {
          before: "Üksikud fotod kaameras",
          after: "Meedia seotud sinu hobusega",
        },
        {
          before: "Suulised kokkulepped",
          after: "Ülesanded ja meeldetuletused kinnitusega",
        },
        {
          before: "Paberpassport kadunud",
          after: "Dokumendid alati käepärast",
        },
      ],
    },
    helper: {
      title: "Milline hobusehalduse rakendus sobib sulle?",
      lead: "Vasta nendele 5 küsimusele ja saad ausa soovituse — ka siis, kui see ei ole alati EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Kas sul on üks hobune või mitu hobust?",
          options: [
            {
              label: "Üks hobune",
              score: 1,
            },
            {
              label: "2–5 hobust",
              score: 2,
            },
            {
              label: "Rohkem kui 5 hobust",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Kas haldad klientide või kolmandate isikute hobuseid?",
          options: [
            {
              label: "Ei, ainult oma hobuseid",
              score: 0,
            },
            {
              label: "Mõnikord — perekonnale või tuttavatele",
              score: 1,
            },
            {
              label: "Jah, professionaalselt (tall / maneež)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Kas soovid jälgida aretustegevust ja tiinust?",
          options: [
            {
              label: "Pole asjakohane",
              score: 0,
            },
            {
              label: "Mõnikord — juhusliku aretuse puhul",
              score: 1,
            },
            {
              label: "Jah, olen (või saan olema) aretaja",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Kas teed koostööd treeneri, hooldaja või spetsialistiga?",
          options: [
            {
              label: "Ei, teen kõike ise",
              score: 0,
            },
            {
              label: "Jah, ühe inimesega",
              score: 1,
            },
            {
              label: "Jah, mitme inimesega",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Kas soovid ainult registreerida või saada ka ülevaateid?",
          options: [
            {
              label: "Ainult registreerimine",
              score: 1,
            },
            {
              label: "Registreerimine + planeerimine",
              score: 2,
            },
            {
              label: "Registreerimine + planeerimine + ülevaated",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Lihtne logiraamat on piisav — ja kasvab koos sinuga.",
          body: "Ühe hobuse jaoks ilma jagatud hoolduseta sobib iga hobusehalduse rakendus. EquiSight algab tasuta 1 hobusega, seega pole riske. Kui hiljem soovid lisada rohkem hobuseid, treeneri või aretustegevuse, on kõik juba olemas.",
          cta: "Alusta tasuta 1 hobusega",
        },
        mid: {
          title: "EquiSight sobib hästi sinu olukorraga.",
          body: "Sul on mitu vajadust (mitu hobust, koostöö või ülevaated). Enamik konkurente katab 1–2 moodulit; EquiSight ühendab need kõik ühes rakenduses, ilma et peaksid eraldi tööriistu ühendama.",
          cta: "Vaata, mida EquiSight suudab",
        },
        high: {
          title: "EquiSight on kõige loogilisem valik.",
          body: "Sinu olukord ühendab mitu hobust, koostöö, aretustegevuse ja/või ülevaated. See on täpselt see, kus EquiSight vahet teeb — mitte killustunud tööriistad, vaid üks hobuse toimik kõige ja kõigi jaoks hobuse ümber.",
          cta: "Alusta tasuta EquiSight'iga",
        },
      },
    },
    faqTitle: "Korduma kippuvad küsimused hobusehalduse rakenduste kohta",
    faq: [
      {
        q: "Mis on parim hobusehalduse rakendus?",
        a: "Parim hobusehalduse rakendus sõltub sinu olukorrast. Lihtsaks logiraamatuks sobivad mitmed rakendused. Kui soovid ühendada tervise, treeningu, toitumise, dokumendid, aretustegevuse, planeerimise ja koostöö, siis on EquiSight ehitatud täieliku lahendusena, kus kõik koondub ühte toimikusse.",
      },
      {
        q: "Kas saan hallata mitut hobust ühes rakenduses?",
        a: "Jah. Hea hobusehalduse rakendus peab toetama mitut hobust, sealhulgas omanikke, hooldajaid, rutiine, dokumente, kohtumisi ja meeldetuletusi iga hobuse kohta. EquiSight on selleks loodud esimesest koodireal — hobused on individuaalsed toimikud, mitte read loendis.",
      },
      {
        q: "Kas EquiSight sobib ka aretusfarmidele?",
        a: "Jah. EquiSight'i saab seadistada aretusfunktsioone kasutama, nagu mära tsükkel, seemendamise kuupäev, tiinuse kontroll, täkuandmed, sugupuu, eeldatav varsumiskuupäev ja varsa areng. See on täpselt valdkond, kus enamik konkureerivaid rakendusi ei paku piisavalt lahendusi.",
      },
      {
        q: "Kas saan jagada andmeid oma treeneri või hobusesepa ga?",
        a: "Jah. EquiSight'i eesmärk on, et asjakohast teavet saab turvaliselt jagada hobuse ümber olevate inimestega — treener, hobusesepp, hambaarst, veterinaararst, füsioterapeut, hooldaja või omanik. Igaüks saab ainult need õigused, mis on vajalikud tema rolli täitmiseks.",
      },
      {
        q: "Miks mitte lihtsalt kasutada WhatsAppi või Excelit?",
        a: "WhatsApp ja Excel toimivad, kuni asjad on lihtsad. Niipea kui sul on mitu hobust, kohtumisi, dokumente, ravimeetodeid, omanikke või aretusandmeid, muutub see veaaltiks: teave hajub laiali, otsimine võtab aega ja suulised kokkulepped ununevad. Hobusehalduse rakendus koondab kõik hobuse kaupa kokku koos automaatsete meeldetuletustega.",
      },
      {
        q: "Mida EquiSight maksab?",
        a: "Alustada saab tasuta 1 hobusega. Kui soovid hallata mitut hobust, aktiveerida aretusmoodulit või anda spetsialistidele juurdepääsu, on saadaval taskukohased Premium-plaanid. Vaata praeguseid võimalusi hinnalehelt.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Aretustarkvara hobustele: täielik võrdlus 2026",
      description: "Võrdle hobuste aretustarkvarа: mära tsükkel, tiinus, täkuvalik ja varssad. Avasta, miks EquiSight on täielik aretustarkvara.",
      keywords: [
        "aretustarkvara hobune",
        "mära tsükli rakendus",
        "mära tiinuse rakendus",
        "varsa registreerimise rakendus",
        "tõuraamat rakendus hobune",
        "paaritamisplaan hobune",
        "täkuvaliku rakendus",
      ],
    },
    hero: {
      eyebrow: "Valikuabi · aretustarkvara",
      breadcrumbLabel: "Aretustarkvara",
      title: "Aretustarkvara hobustele: täielik võrdlus 2026.",
      intro: "Aretusmära väärib enamat kui üldine hobusehaldurakendus. Võrdle tuntud tööriistade aretusfunktsioone, avasta, millele tõeliselt tähelepanu pöörata, ja vali teadlikult tarkvara, mis sobib sinu tallile — suurele või väiksele.",
      pills: [
        {
          icon: "Baby",
          label: "Mära tsükkel",
        },
        {
          icon: "Heart",
          label: "Tiinuskontroll",
        },
        {
          icon: "Sparkles",
          label: "Varsa areng",
        },
        {
          icon: "FileText",
          label: "Tõuraamat",
        },
      ],
      ctas: [
        {
          label: "Alusta tasuta aretusemooduliga",
          href: "#start",
          primary: true,
        },
        {
          label: "Vaata võrdlustabelit",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miks tavaline hobusehaldusrakendus aretuseks ei sobi.",
      lead: "Enamik ratsaspordirakendusi on loodud ühe spordi- või harrastusliku hobuse jaoks. Aretus nõuab hoopis teistsugust rütmi: jooksmine, seemendamine, tiinuskontroll, ultrahelid, varsaikalender, sugupuu ja müük. Üks Excel läheb pärast 2 hooaega korrast ära — ja mitme mära puhul kaotad ülevaate.",
      items: [
        "Millal oli Bonita viimane tsükkel?",
        "Milline täkk on järgmiseks hooajaks paaritamiseks planeeritud?",
        "Kas 21-päevane ultraheli on juba planeeritud?",
        "Millised 2024. aasta varssad on juba müüdud?",
        "Kus on sugupuudiagramm emakülje vanaisani?",
        "Kus on DNA-proovid ja passandmed?",
      ],
    },
    what: {
      title: "Mis on hobuste aretustarkvara?",
      lead: "Aretustarkvara on spetsialiseeritud toimik iga mära ja täku kohta, koos aretushooaja kalendri, tiinusplaneerimise, varsa registreerimise ja sugupuu kuvamisega. Mitte üldine hobuselogiraamat, vaid tööriist, mis mõistab aretustsüklit: esimesest jooksmisest kuni võõrutamiseni.",
      targetGroupsTitle: "Millisele aretajatüübile on aretustarkvara mõeldud?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Harrastusaretaja (1–3 mära)",
          body: "Üks või kaks paaritamist aastas — ülevaade ilma Exceli akrobaatikata.",
        },
        {
          icon: "Building2",
          title: "Väike tall (4–10 mära)",
          body: "Aretushooaja plaan koos tsükli, seemendamise, tiinuskontrollide ja varsatoimikuga.",
        },
        {
          icon: "Users",
          title: "Professionaalne tall (10+)",
          body: "Mitu töötajat, täkuvalik iga mära jaoks, müük ja turundus.",
        },
        {
          icon: "Target",
          title: "Täkupidaja",
          body: "Tellimisajalugu, spermastatistika ja kalender iga täku kohta.",
        },
        {
          icon: "Heart",
          title: "Embrüosiirdamine",
          body: "Doonor- ja retsipiendimära ühendatud toimikuna, ET-kalender.",
        },
        {
          icon: "ClipboardList",
          title: "Tõuraamatu registreerimine",
          body: "DNA-proovid, passidokumendid ja sugupuuandmed.",
        },
      ],
    },
    criteria: {
      title: "Millistele nõuetele peab hea aretustarkvara vastama?",
      lead: "Kõik hobusеrakenduste 'aretusfunktsioonid' ei ole ühesugused. Viis põhivaldkonda, kus aretajad kaotavad palju aega — ja kus tarkvara teeb tõeliselt vahe.",
      items: [
        {
          icon: "Calendar",
          title: "Mära tsükkel ja jooksmine",
          body: "Igapäevane logi, ovulatsiooni ennustamine, tsükli edasijõudmine ja automaatsed meeldetuletused.",
        },
        {
          icon: "Heart",
          title: "Seemendamine ja tiinuskontroll",
          body: "Paaritamis- ja seemendamiskuupäevad, täkuandmed, 14-päevane ultraheli, 21-päevane ultraheli, 60-päevane ultraheli ja soo määramine.",
        },
        {
          icon: "Baby",
          title: "Varsa areng",
          body: "Sünniandmed, kaalugraafik, ussiraviskeem, võõrutamisaeg, passi registreerimine.",
        },
        {
          icon: "FileText",
          title: "Sugupuu ja dokumendid",
          body: "Sugupuu kuvamine kuni 4–5 põlvkonnani, DNA, passinumbrid ja tõuraamatu staatus.",
        },
        {
          icon: "Target",
          title: "Täkuvalik ja sobitamine",
          body: "Filtreerimine distsipliini, liinide, täkuandmete ja varasema edu järgi — mitte ainult selle järgi, mida täkupidaja reklaamib.",
        },
        {
          icon: "Share2",
          title: "Koostöö veterinaar/seemendajaga",
          body: "Ultrahelid, proovid ja staatused jagatakse otse kliinikuga, kes töötab sinu märadega.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs teised aretustarkvarad.",
      lead: "Hollandi otsingutulemused aretustarkvara kohta näitavad sageli üldisi hobusеrakendusi, mis mainivad aretust vaid ühes lauses. Võrdleme ausalt, millistel tööriistadel on tõeliselt täielik aretusprotsess.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Tasuta alustamine",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Mära tsükli logimine",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Seemendamiskuupäev + täkk",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrahelid ja tiinuskontroll",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Eeldatav varsumiskuupäev",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Varsa toimik (kaal/kasv)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Sugupuu kuni 4–5 põlvkonnani",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA ja passi registreerimine",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Täkuvalik / sobitamine",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embrüosiirdamine",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Mitme mära ülevaade",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobiil (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Jagamine veterinaariga",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integreeritud üldise toimikuga",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Varssade müük ja turundus",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Võrdlus põhineb jaanuaris 2026 avalikult kättesaadavatel funktsioonidel. EquineGenie on aretuses tugevaim, kuid nõrgem mobiili ja üldise hobusehalduse poolest. EquiSight ühendab mõlemad.",
    },
    why: {
      title: "Miks EquiSight teenindab aretajaid teistmoodi.",
      lead: "Paljud aretajad kasutavad eraldi aretustarkvarа ja eraldi hobusehaldusrakendust. EquiSight ühendab mõlemad — ilma rakenduste vahel lülitamise või andmete topeltsisestamiseta.",
      points: [
        {
          icon: "Heart",
          title: "Aretusmära jääb ka lihtsalt hobuseks",
          body: "Aretusmäral on nii aretushooaeg kui ka tavaline hobusetoimik — tervis, vaktsiinid, kabjasepp. Üks rakendus, kõik moodulid.",
        },
        {
          icon: "Sparkles",
          title: "Ennustav, mitte reaktiivne",
          body: "Tsükli ennustus, tiinuse vahe-eesmärkide meeldetuletused ja varsaikalender — automaatselt sinu andmete põhjal.",
        },
        {
          icon: "Share2",
          title: "Kõik aretuse ümber",
          body: "Seemendaja, täkupidaja, veterinaar, ostja, tõuraamat — kõigil juurdepääs õigete õigustega.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Distsipliini kaupa · tsüklist võõrutamiseni",
      title: "Mida sisaldab aretustoimik EquiSight'is.",
      lead: "Iga mära jaoks saad täieliku aretustoimiku, mis on seotud tema tavapärase hobusetoimikuga.",
      items: [
        "Igapäevane tsüklilogi koos ennustusega",
        "Seemendamine/paaritamine + täkuandmed",
        "Ultraheli ajaskaala (14/21/60 päeva + sugu)",
        "Tiinuse vahe-eesmärgid automaatsete meeldetuletustega",
        "Eeldatav varsumiskuupäev ja ettevalmistus",
        "Varsa toimik alates sünnist",
        "Sugupuu kuni vanavanemateni klõpsude navigeerimisega",
        "DNA-proov, pass, tõuraamatu staatus",
        "Müügitoru huvilistega",
        "Täkuvaliku ajalugu iga mära kohta",
      ],
      ctaLabel: "Vaata aretusemoodulit",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Kogu talli jaoks",
      title: "Ülevaade mitmest märast ja täkkudest.",
      lead: "Kui aredad rohkem kui 2–3 märaga, muutub ülevaade kõigist tsüklitest ja tiinustest kriitiliseks.",
      cards: [
        {
          t: "Tsüklite armatuurlaud",
          d: "Kõik märad kõrvuti koos tsüklietapi ja järgmise tegevusega.",
        },
        {
          t: "Tiinuste torujuhe",
          d: "Millised märad on kus tiinuse vahe-eesmärkidel?",
        },
        {
          t: "Varsade kalender",
          d: "Eeldatavad sündimised kuude kaupa, logistika sellele vastavalt planeeritud.",
        },
        {
          t: "Täkude portfell",
          d: "Omad täkud või püsiseemendajad koos tellimisajalooga.",
        },
        {
          t: "Sugupuugraafik",
          d: "Eellaste analüüs mitme põlvkonna ja liini ulatuses.",
        },
        {
          t: "Müügi armatuurlaud",
          d: "Millised varssad on müüdud, broneeritud või veel saadaval.",
        },
      ],
    },
    beforeAfter: {
      title: "Excelist ja kalendrist EquiSight aretuseni.",
      lead: "Konkreetselt: nii muutub sinu aretuшоаeg.",
      rows: [
        {
          before: "Tsükkel eraldi märkmes",
          after: "Igapäevane logi koos ennustusega",
        },
        {
          before: "Ultrahelid seemendajale WhatsApp'i kaudu",
          after: "Jagatud toimik koos fotodega",
        },
        {
          before: "Tiinuskuupäev kalendris",
          after: "Automaatsed vahe-eesmärkide meeldetuletused",
        },
        {
          before: "Varsa pass sahtlis",
          after: "Dokument seotud varsa profiiliga",
        },
        {
          before: "Sugupuu paberil",
          after: "Klõpsatav sugupuu kuni 4–5 põlvkonnani",
        },
        {
          before: "Müügikuulutus Marktplaats'il",
          after: "Müügitoru huvilistega",
        },
      ],
    },
    helper: {
      title: "Milline aretustarkvara sobib sulle?",
      lead: "5 küsimust, et selgitada, kas vajad täielikku aretuserakendust või piisab hobivahenditest.",
      questions: [
        {
          id: "mares",
          q: "Mitu aretusmärat hallatad?",
          options: [
            {
              label: "1 mära",
              score: 1,
            },
            {
              label: "2–5 märа",
              score: 2,
            },
            {
              label: "Rohkem kui 5 märа",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Kui tihti aredad aastas?",
          options: [
            {
              label: "Aeg-ajalt (iga paari aasta tagant)",
              score: 0,
            },
            {
              label: "Igal aastal 1–2 paaritamist",
              score: 2,
            },
            {
              label: "Igal aastal 3+ paaritamist",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Kuidas seemendad/paaritad?",
          options: [
            {
              label: "Loomulik paaritamine",
              score: 1,
            },
            {
              label: "KI värske/jahutatud sperma",
              score: 2,
            },
            {
              label: "ET või külmutatud sperma",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Kas teed koostööd veterinaari/seemendajaga?",
          options: [
            {
              label: "Üks püsitöötaja",
              score: 1,
            },
            {
              label: "Mitu kliinikut",
              score: 2,
            },
            {
              label: "Rahvusvaheline võrgustik",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Mida praegu jälgid?",
          options: [
            {
              label: "Excel või paber",
              score: 1,
            },
            {
              label: "Üldine hobusehaldusrakendus",
              score: 2,
            },
            {
              label: "Midagi struktureeritud ei ole",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Hobirist või Excel piisab — kuid EquiSight on siiski kasulik.",
          body: "1 mära jaoks loomuliku paaritamisega iga paari aasta tagant on laialdane aretusemoodul ülemäärane. EquiSight alustab tasuta ja aktiveerid aretusemooduli ainult sellel aastal, kui paaritad — ilma täiendamisele kohustuseta.",
          cta: "Alusta tasuta",
        },
        mid: {
          title: "EquiSight aretusmoodul on õige tööriist.",
          body: "Sul on mitu mära või mitu aretusviisi — selleks ei ole üldised hobusеrakendused loodud. EquiSight ühendab aretuse ja üldise hoolduse, nii et sa ei pea kahe tööriista vahel vahetama.",
          cta: "Vaata aretusemoodulit",
        },
        high: {
          title: "EquiSight on loodud sinu talli jaoks.",
          body: "Mitu märа, ET või külmutatud sperma, rahvusvaheline meeskond — enamik tööriistu jääb siinkohal nõrgaks. EquiSight kasvab koos sinu talliga talli tasemele, ilma et peaksid täiendavaid litsentse koguma.",
          cta: "Räägi meiega talliplaanist",
        },
      },
    },
    faqTitle: "Korduma kippuvad küsimused aretustarkvara kohta",
    faq: [
      {
        q: "Milline on parim aretustarkvara hobustele?",
        a: "1 mära jaoks ilma keeruka aretusviisita piisab paljudest tööriistadest. Alates 2–3 märast, KI või ET kasutamisel või koostöös veterinaari ja tõuraamatuga muutub täielik aretusemoodul kriitiliseks. EquiSight ühendab aretuse üldise hobusehaldusega ühes rakenduses, nii et sul ei ole vaja vahetada.",
      },
      {
        q: "Milliseid aretusfunktsioone on mul tõeliselt vaja?",
        a: "Minimaalselt: tsüklilogi, seemendamise/paaritamise andmed, tiinuse vahe-eesmärgid ja varsa toimik. Valikulised, kuid võimsad: sugupuu kuvamine, täkuvaliku arhiiv, DNA/pass ja müügitoru.",
      },
      {
        q: "Kas EquiSight suudab mära tsüklit ennustada?",
        a: "Jah. EquiSight kasutab varasemaid tsükliandmeid, et näidata eeldatavat ovulatsiooni, nii et planeerid seemendamise või paaritamise õigel hetkel — ilma igapäevase arvamiseta.",
      },
      {
        q: "Kas EquiSight töötab ka embrüosiirdamiseks?",
        a: "Jah. Doonor- ja retsipiendimära saavad seotud toimikud, ET-kalendri ja jagatud vahe-eesmärgid kliinikuga. Nii ei kaota sa ajaskaala keerulises ET-protsessis.",
      },
      {
        q: "Kas saan oma olemasolevad aretuseandmed importida?",
        a: "Saad sisestada tsükleid, paaritamisi ja varsaandmeid käsitsi või partiina CSV kaudu. Aktiivsete tallide puhul aitame ühekordse migratsiooniga, kui sul on mitme hooaja andmed olemas.",
      },
      {
        q: "Kuidas jagan toimikut oma veterinaari või seemendajaga?",
        a: "Igale isikule antakse juurdepääs rolliga: veterinaar, seemendaja, täkupidaja või tõuraamatu ametnik. Kõik näevad ainult seda teavet, mis on nende rolli jaoks vajalik — täielik juurdepääs ei ole vajalik.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Tallihaldustarkvara: täielik võrdlus ja valikuabi 2026",
      description: "Võrdle tallihaldustarkvarasid tundide, ratsanike, hobuste ja halduse jaoks. Avasta, milline rakendus sobib sinu tallile või pensionitallle.",
      keywords: [
        "tallihaldustarkvara",
        "talli halduse rakendus",
        "talli halduse tarkvara",
        "tundide planeerimine tallis",
        "pensionitalli tarkvara",
        "ratsaniku haldus",
        "hobuste haldus tallis",
      ],
    },
    hero: {
      eyebrow: "Valikuabi · tallihaldustarkvara",
      breadcrumbLabel: "Tallihaldustarkvara",
      title: "Tallihaldustarkvara: täielik valikuabi tallidele ja pensionitallidele.",
      intro: "Tundide planeerimine, ratsanike haldus, hobuste hooldus, arveldamine ja suhtlus — hea tallihaldustarkvara koondab kõik ühte kohta. Võrdle tuntumaid lahendusi ja avasta, milline sobib sinu tallile.",
      pills: [
        {
          icon: "Calendar",
          label: "Tundide planeerimine",
        },
        {
          icon: "Users",
          label: "Ratsanikud ja kliendid",
        },
        {
          icon: "Heart",
          label: "Hobuste hooldus",
        },
        {
          icon: "CreditCard",
          label: "Arveldamine",
        },
      ],
      ctas: [
        {
          label: "Telli demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Võrdlustabelile",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miks hajutatud tööriistad teevad talli aeglaseks.",
      lead: "Enamik tallesid töötab lapitöö peal: tundide planeerimine tahvlil, ratsanike registreerimine Excelis, arveldamine eraldi tööriistas, hobuste hooldus WhatsAppis ja omanikuga suhtlemine isiklike sõnumite kaudu. Kiirel nädalal tekivad topeltbroneeringud, unustatud arved või hobused, kes ei tea, milline ratsanik neid saab.",
      items: [
        "Kes on praegu Jasmiini tunnis?",
        "Milline ratsanik ei ole märtsikuu eest maksnud?",
        "Millist hobust ei tohi sel nädalal kasutada?",
        "Kes on õpilaste hädaabikontaktid?",
        "Kas Stardust'i omanik on sepa arve kätte saanud?",
        "Milline hobune on millises boksis?",
      ],
    },
    what: {
      title: "Mis on tallihaldustarkvara?",
      lead: "Tallihaldustarkvara ühendab tundide planeerimise, ratsanike halduse, hobuste hoolduse, arveldamise ja suhtluse ühte tööriista. Ei mingit Excel-akrobaatikat ega WhatsAppi segadust — ainult üks koht, kus tall töötab ja omanikud ning ratsanikud saavad ülevaate.",
      targetGroupsTitle: "Millisele ettevõttetüübile on tallihaldustarkvara mõeldud?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Väike tall (1–15 hobust)",
          body: "Peamiselt tundide planeerimine ja maksed — haldus ilma peavaevata.",
        },
        {
          icon: "Users",
          title: "Keskmise suurusega tall (15–40 hobust)",
          body: "Mitu instruktorit, tundide planeerimine + hobuste graafik + ratsanike haldus.",
        },
        {
          icon: "ClipboardList",
          title: "Suur ratsatall ja pensionitall (40+)",
          body: "Täielik tegevus koos arveldamise, söötmis- ja sepaplaneerimisega.",
        },
        {
          icon: "Heart",
          title: "Pensionitall",
          body: "Omaniku portaal, individuaalsed hooldusejuhised, jagatud kalender.",
        },
        {
          icon: "Target",
          title: "Takistussõidu treeningtall",
          body: "Võistluste planeerimine, treenimine hobuse kaupa, kliendikontakt.",
        },
        {
          icon: "FileText",
          title: "Ratsaspordiettevõtjad",
          body: "Tundide, pensioni, kliinikute ja kauplemise segu — kõik ühest süsteemist.",
        },
      ],
    },
    criteria: {
      title: "Millele peab hea tallihaldustarkvara vastama?",
      lead: "Ilus rakendus ei tähenda midagi, kui töötajad sellega töötada ei taha. Viis praktilist kriteeriumi, mis teevad vahe edu ja pettumuse vahel.",
      items: [
        {
          icon: "Calendar",
          title: "Mitmeastmeline tundide planeerimine",
          body: "Algajad/edasijõudnud, koolisõit/takistussõit, hobuse-ratsaniku seosed ja instruktorite kalendrid — kõik korraga nähtavad.",
        },
        {
          icon: "Users",
          title: "Ratsanike haldus",
          body: "Profiilid, tase, abonement, tunnipakettide kaardid ja pereliidete seosed noorratsanikele.",
        },
        {
          icon: "Heart",
          title: "Hobuste graafik",
          body: "Millist hobust kui tihti kasutatakse, koos puhkeperioodide, vigastuste ja taastusraviga.",
        },
        {
          icon: "CreditCard",
          title: "Arveldamine ja abonementid",
          body: "Kuuabonementid, tunnipakettide kaardid, üksiktunnid ja automaatne inkasso.",
        },
        {
          icon: "Share2",
          title: "Omaniku portaal (pensionitall)",
          body: "Omanikud näevad oma hobust oma rakenduses — kalender, kulud, sepp ja märkmed ilma helistamiseta.",
        },
        {
          icon: "Bell",
          title: "Suhtlus ja meeldetuletused",
          body: "Automaatsed tunni meeldetuletused, makseteated, sepa kuulutused — ilma sõnumivahetuseta.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs teised tallihaldustarkvarad.",
      lead: "Paljud talli tööriistad on tugevad tundide planeerimisel või arveldamisel, kuid harva mõlemas koos hobuste hoolduse ja omanikuga suhtlemisega. Võrdleme neid ausalt kõrvuti.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Tasuta alustamine / prooviperiood",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Tundide planeerimine",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Mitu instruktorit",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ratsanike haldus",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Hobuste graafik",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Hobuste hooldus (vaktsineerimine/sepp)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tunnipakett / abonement",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Veebimaksed",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automaatne arveldamine",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Omaniku portaal (pension)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sepa/veterinaari integratsioon",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS meeldetuletused",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobiil (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Võistluste planeerimine",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sobib pensionitallile",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Võrdlus põhineb 2026. aasta jaanuaris avalikult kättesaadavatel funktsioonidel. Stalmanager on tugev halduse poolel, EquiSight eristub pensionitalli töövoo, hobuste hoolduse ja omaniku portaali poolest.",
    },
    why: {
      title: "Miks EquiSight on tallidele ja pensionitallidele teistsugune.",
      lead: "EquiSight läheb kaugemale kui lihtsalt tunniplaneerija. Me näeme talli kui täielikku operatsiooni: hobused, inimesed, suhtlus ja raha — kõik sõltuvad üksteisest.",
      points: [
        {
          icon: "Heart",
          title: "Hobune keskel, mitte kalender",
          body: "Igal hobusel on oma toimik. Tunnikasutus, tervis, sepp ja võistlused ühes ajajoones — mitte 3 eraldi tööriistas.",
        },
        {
          icon: "Share2",
          title: "Omanikud näevad infot ilma helistamiseta",
          body: "Pensionitalli omanikel on oma vaade: kulud, planeerimine, fotod ja märkmed — säästab 5–10 telefonikõnet nädalas.",
        },
        {
          icon: "Bell",
          title: "Automaatne suhtlus",
          body: "Tunni meeldetuletus, vaktsineerimise meeldetuletus, arve — automaatselt, rakenduse/e-posti/SMS kaudu. Enam mitte WhatsAppi grupid.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pensionitallile",
      title: "Mida pensionitall EquiSight'iga saab.",
      lead: "Pensionitallil on ainulaadsed väljakutsed, mida tavaline tallihaldustarkvara ei lahenda.",
      cards: [
        {
          t: "Omaniku portaal",
          d: "Iga omanik näeb ainult oma hobust (hobuseid), kalendrit ja kulusid.",
        },
        {
          t: "Hooldusejuhised hobuse kaupa",
          d: "Sööt, heinad, toidulisandid, tekikava — tallile nähtav.",
        },
        {
          t: "Jagatud kalender",
          d: "Sepp, veterinaari ja omaniku külastus ühes vaates.",
        },
        {
          t: "Tarbimiskulud hobuse kaupa",
          d: "Allapanu, sööt, kraftsööt arvestatakse iga omaniku peale.",
        },
        {
          t: "Hobuse hädaabikontaktid",
          d: "Omanik, veterinaari ja sepp on tallile alati leitavad.",
        },
        {
          t: "Karjatamise haldus",
          d: "Millised hobused lähevad karjamaale, puhkusele või taastusravile?",
        },
      ],
    },
    beforeAfter: {
      title: "Tahvlilt ja Excelist EquiSight'i.",
      lead: "Konkreetselt: nii muutub töönädal tallis.",
      rows: [
        {
          before: "Tahvel tundide planeerimisega",
          after: "Reaalajas planeerimine instruktori kaupa",
        },
        {
          before: "Excel ratsanike ja tunni märkmetega",
          after: "Kliendi CRM koos tunni ajalooga",
        },
        {
          before: "WhatsApp omanikele",
          after: "Omaniku portaal nende hobuse jaoks",
        },
        {
          before: "Kuuinkasso käsitsi",
          after: "Automaatne arveldamine + iDEAL",
        },
        {
          before: "Hobuse hooldus paperpinnal",
          after: "Hooldusejuhised hobuse kaupa, jagatud",
        },
        {
          before: "Suuline kokkulepe sepaga",
          after: "Sepa planeerimine koos kinnitustega",
        },
      ],
    },
    helper: {
      title: "Milline tallihaldustarkvara sobib sulle?",
      lead: "5 küsimust, et selgitada välja, kas EquiSight on õige platvorm sinu tallile või pensionitallile.",
      questions: [
        {
          id: "size",
          q: "Mitu hobust on sinu ettevõttes?",
          options: [
            {
              label: "Vähem kui 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Rohkem kui 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Mis on sinu põhitegevus?",
          options: [
            {
              label: "Peamiselt tundide andmine",
              score: 1,
            },
            {
              label: "Pensionitall (hobused pensionil)",
              score: 3,
            },
            {
              label: "Tundide ja pensioni segu",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Mitme instruktoriga koos töötad?",
          options: [
            {
              label: "Ainult mina ise",
              score: 1,
            },
            {
              label: "2–3 instruktorit",
              score: 2,
            },
            {
              label: "4 või rohkem",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Kuidas korraldad praegu arveldamist?",
          options: [
            {
              label: "Käsitsi (Word/Excel)",
              score: 3,
            },
            {
              label: "Eraldi raamatupidamisprogramm",
              score: 2,
            },
            {
              label: "Integreeritud tunnitööriista",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Kuidas suhtled omanikega?",
          options: [
            {
              label: "Isiklikult / WhatsApp",
              score: 3,
            },
            {
              label: "E-post + WhatsApp",
              score: 2,
            },
            {
              label: "Omaniku portaal tööriistas",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Lihtne tööriist või Excel sobib praegu — kuid EquiSight kasvab koos sinuga.",
          body: "Väikesele tundide ettevõttele ühe instruktori ja vähese pensioniga ei ole ulatuslik pakett kohe vajalik. EquiSight alustab tasuta ja kasvab koos sinu talliga — mitte mingit migreerimisvalu mõne aasta pärast.",
          cta: "Alusta tasuta",
        },
        mid: {
          title: "EquiSight on loogiline uuendus sinu tallile.",
          body: "Mitu instruktorit, tundide ja pensioni segu või arveldamine, mis on praegu eraldi — EquiSight koondab selle ühte töövoogu. Eriti omaniku portaal säästab palju ad hoc suhtlemist.",
          cta: "Telli demo",
        },
        high: {
          title: "EquiSight on loodud sinu mastaabi jaoks.",
          body: "Pensionitall + tunnid + mitu instruktorit on täpselt see, kus EquiSight eristub klassikalistest tallihaldustarkvaradest. Omaniku portaal ja hobuste hoolduse integratsioon säästavad iganädalaselt tunde haldust ja suhtlemist.",
          cta: "Plaani demo oma tallile",
        },
      },
    },
    faqTitle: "Korduma kippuvad küsimused tallihaldustarkvara kohta",
    faq: [
      {
        q: "Mis on parim tallihaldustarkvara?",
        a: "Puhta tundide planeerimise jaoks on mitu head valikut. Niipea kui vajad pensionitalli, mitut instruktorit või hobuste hoolduse jälgimist, saab EquiSight'ist täielik lahendus — ei mingit tööriistavaheldust, kõik ühes kohas.",
      },
      {
        q: "Kas saan olemasolevad kliendid ja tunnid importida?",
        a: "Jah. Kliendiandmeid ja tunnigraafikuid saab importida CSV kaudu. Aitame aktiivseid tallesid ühekordse migratsiooniga, et sa ei peaks 200 ratsanikku käsitsi sisestama.",
      },
      {
        q: "Kas see töötab ka pensionitalli jaoks ilma tundideta?",
        a: "Jah. Pensionitalli režiim lülitab tunnid välja ja keskendub omaniku portaalile, söötmisele/hooldusele, sepa planeerimisele ja kulude arvestamisele hobuse kaupa.",
      },
      {
        q: "Kas ratsanikud saavad ise registreeruda ja maksta?",
        a: "Jah. Ratsanikud saavad oma konto kaudu näha, millised tunnid on avatud, registreeruda, maksta õppemaksu iDEAL'iga ja osta tunnipakettide kaarte.",
      },
      {
        q: "Kuidas on hobuse ja omaniku andmete privaatsusega?",
        a: "Igal isikul on roll (omanik, ratsanik, instruktor, töötaja). Iga rolli puhul näed ainult seda, mida vajad. Omanikud näevad ainult oma hobust, ratsanikud ainult oma tunde.",
      },
      {
        q: "Kas EquiSight saab integreeruda minu raamatupidamistarkvaragа?",
        a: "Jah, integratsioonid Exact, Moneybird ja e-Boekhouden on saadaval. Arved liiguvad siis automaatselt sinu raamatupidamisse.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Treenerirakendus hobusele: võrdlus ja valikujuhend treeneritele 2026",
      description: "Võrdle treenerirakendusi hobuse ja ratsutaja jaoks: treeningupäevik, video, eesmärgid, protokollianalüüs ja kliendihaldus. Leia õige tööriist treeneritele.",
      keywords: [
        "treenerirakendus hobusele",
        "instruktori rakendus",
        "hobuse treeningurakendus",
        "ratsutaja coachingu rakendus",
        "treeningupäevik hobusele",
        "dressuuriprotokolli analüüsimine",
        "hobusetreeneri tarkvara",
      ],
    },
    hero: {
      eyebrow: "Valikujuhend · treenitarkvara",
      breadcrumbLabel: "Treenerirakendus",
      title: "Treenerirakendus hobusele: täielik valikujuhend instruktoritele ja treeneritele.",
      intro: "Treener või instruktor žongleerib kombinatsioonide, tundide, videote, eesmärkide ja võistlustega. Võrdle parimaid treenerirakendusi hobuseinimestele ja vali platvorm, mis kasvab sinuga koos ka 2026. aastal.",
      pills: [
        {
          icon: "Target",
          label: "Eesmärgid ja planeerimine",
        },
        {
          icon: "Video",
          label: "Videoanalüüs",
        },
        {
          icon: "TrendingUp",
          label: "Edasiminek",
        },
        {
          icon: "Users",
          label: "Kliendid/kombinatsioonid",
        },
      ],
      ctas: [
        {
          label: "Alusta treenerina tasuta",
          href: "#start",
          primary: true,
        },
        {
          label: "Võrdlustabelisse",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Miks WhatsApp-coaching treenereid takistab.",
      lead: "Enamik treenereid töötab eraldi tööriistadega: WhatsApp suhtluseks, märkmik tundide jaoks, YouTube või WeTransfer videote jaoks ning Excel võistlustulemuste jaoks. Viie ratsutajaga see toimib. Kahekümne ratsutajaga läheb info kaduma, eesmärgid ununevad ja individuaalne areng jääb silmist.",
      items: [
        "Kus on Anouки eesmärk selleks hooajaks?",
        "Millise video saatsin eelmisel kuul Bramile?",
        "Kas Lara on näinud oma viimase võistluse protokollianalüüsi?",
        "Kui tihti treenib iga kombinatsioon nädalas?",
        "Kas Stardust' omanik on mu treeningjuhise läbi lugenud?",
        "Millal andsin viimati tagasisidet kõikuva impulsi kohta?",
      ],
    },
    what: {
      title: "Mis on treenerirakendus hobusele ja ratsutajale?",
      lead: "Treenerirakendus ühendab coaching-CRM-i (kombinatsioonid, tunnid, eesmärgid), treeningupäeviku hobuse kohta, videotaguasside, võistlusplaneerimise ja protokollianalüüsi. Ei mingit eraldi WhatsAppi/YouTube'i/Excelit — üks platvorm, kus treener ja ratsutaja koos töötavad.",
      targetGroupsTitle: "Millisele treeneri tüübile see on mõeldud?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dressuuriinstruktor",
          body: "Protokolli skannimine, žürii kommentaaride sidumine treeningueesmärkidega, progressi jälgimine.",
        },
        {
          icon: "Activity",
          title: "Takistussõidu treener",
          body: "Rajaplaneerimine, vooru tagasiside, tõkete kõrguse haldamine hobuse kaupa.",
        },
        {
          icon: "Award",
          title: "Eventing-treener",
          body: "Kolm ala, kolm plaani — kõik kõrvuti nähtavad.",
        },
        {
          icon: "TrendingUp",
          title: "Tippsoorituse treener (sport)",
          body: "EPI jälgimine, võistlused, eesmärgid — tippspordiga tegijatele ja nende meeskondadele.",
        },
        {
          icon: "Users",
          title: "Maneeži instruktor",
          body: "Grupiõpe + individuaalne coaching ühes rakenduses.",
        },
        {
          icon: "Heart",
          title: "Harrastustreener",
          body: "Hobiteraappia, algajad, ühe hobusega omanikud.",
        },
      ],
    },
    criteria: {
      title: "Millele peab hea treenerirakendus vastama?",
      lead: "Treenimine on inimlik töö, kuid õige tööriist muudab sind 30–50% efektiivsemaks ja aitab ratsutajatel ka tundide vahel areneda.",
      items: [
        {
          icon: "Users",
          title: "Kombinatsioonide haldus",
          body: "Hobune + ratsutaja ühe üksusena, koos taseme, eesmärkide, progressi ja ajalooga.",
        },
        {
          icon: "ClipboardList",
          title: "Tunnikonspektid ja eesmärgid",
          body: "Iga tunni märkmed fookuspunktidega, seotud pikaajaliste eesmärkidega.",
        },
        {
          icon: "Video",
          title: "Videotaguasi",
          body: "Laadi video üles, märgista hetki, lisa räägitud või kirjalik tagasiside.",
        },
        {
          icon: "Target",
          title: "Võistlus- ja protokollianalüüs",
          body: "Skanneeri protokolle (KNHS/FEI), vaata tulemusi osa kaupa, žürii kommentaare ja trende.",
        },
        {
          icon: "Calendar",
          title: "Planeerimine ja tunnikaardid",
          body: "Kalender, maksed, tellimused ja automaatsed meeldetuletused.",
        },
        {
          icon: "Share2",
          title: "Suhtlus ratsutajaga",
          body: "Ratsutaja näeb oma lehekülge tundide, videote, eesmärkide ja tagasisidega.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs teised treenerirakendused.",
      lead: "Mõned treenitööriistad keskenduvad WhatsAppi asendamisele, teised protokollianalüüsile. EquiSight ühendab mõlemad tõelise hobusedossieeriga — nii et ratsutaja areneb ka tundide vahel.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Tasuta alustamine",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinatsioonide haldus",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Tunnikonspektid ja tagasiside",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Pikaajalised eesmärgid",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Video üleslaadimine + tagasiside",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokolli skaneerimine",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (sooritusindeks)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Võistluskalender",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Ratsutaja portaal",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Tunnikaart / tellimus",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Veebimaksed",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integreeritud hobusedossieer",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sepp/loomaarst nähtav",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Nii instruktorile KUI ratsutajale",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Mitu hobust ratsutaja kohta",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Võrdlus põhineb jaanuaris 2026 avalikult kättesaadavatel funktsioonidel. EquiSight on ainulaadne protokollianalüüsi + EPI poolest ning ühendab selle üldise hobusehaldusega.",
    },
    why: {
      title: "Miks EquiSight pakub teistsugust treenerikogemust.",
      lead: "Enamik treenitööriistu lõpevad seal, kus tund lõpeb. EquiSight jätkab — hobusedossiiris, võistlusanalüüsis, koostöös loomaarsti ja omanikuga.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokolli skaneerimine → treeningueesmärk",
          body: "Skanneeri KNHS-protokolli ja näe kohe, millised osad vajavad tähelepanu. Eesmärgid kerkivad automaatselt esile.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach tugevdab sinu silma",
          body: "Mitme tunni, võistluse ja protokolli andmed näitavad mustreid, mida peast meeles ei suuda pidada.",
        },
        {
          icon: "Share2",
          title: "Integreeritud hobusega",
          body: "Treener näeb hobuse vaktsineerimisi, sepa külastusi ja vigastuste ajalugu — ei plaanita treeningut taastumise ajal.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Dressuuriks ja takistussõiduks",
      title: "Mida sisaldab coachingu dossieer EquiSight'is.",
      lead: "Iga kombinatsiooni jaoks saad coachingu voo, mis hoiab kõik koos — ei lähe enam midagi WhatsAppis kaduma.",
      items: [
        "Tunnikonspektid fookuspunktidega iga sessiooni kohta",
        "Pikaajalised eesmärgid + vahe-eesmärgid",
        "Video üleslaadimine ajatembelkommentaaridega",
        "KNHS/FEI protokolli skannimine tulemustega",
        "Žürii kommentaarid seotud treeninguga",
        "Võistlustulemused ja EPI trend",
        "Kliendikontakt ja tundide ajalugu",
        "Tunnikaart / tellimus / arved",
        "Progressigraafik ala kaupa",
        "Jagatud juurdepääs hobuse omanikule",
      ],
      ctaLabel: "Vaata treenerimoodulit",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "WhatsApp + YouTube'ist EquiSight Treenerini.",
      lead: "Konkreetselt: nii muutub sinu coaching-töövoog.",
      rows: [
        {
          before: "WhatsApp eraldi videolinkidega",
          after: "Video ajatempel-tagasisidega dossieeris",
        },
        {
          before: "Märkmik ratsutaja kohta",
          after: "Coaching-logi eesmärkide ja ajalooga",
        },
        {
          before: "Excel võistlusttulemustega",
          after: "EPI graafik + protokollianalüüs",
        },
        {
          before: "Suulised eesmärgid",
          after: "Vahe-eesmärgid progressiindikaatoriga",
        },
        {
          before: "Eraldi arveldusrakendus",
          after: "Tunnid + iDEAL + tellimus rakenduses",
        },
        {
          before: "E-kiri omanikule progressi kohta",
          after: "Omanik jälgib omas vaates",
        },
      ],
    },
    helper: {
      title: "Milline treenerirakendus sobib sulle?",
      lead: "5 küsimust, et näha, kas spetsiaalne coachingtööriist lisab sinu praktikale väärtust.",
      questions: [
        {
          id: "clients",
          q: "Kui palju aktiivseid kombinatsioone sa juhendad?",
          options: [
            {
              label: "Vähem kui 5",
              score: 1,
            },
            {
              label: "5–15",
              score: 2,
            },
            {
              label: "Rohkem kui 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Mis on sinu peamine ala?",
          options: [
            {
              label: "Dressuur",
              score: 3,
            },
            {
              label: "Takistussõit",
              score: 2,
            },
            {
              label: "Harrastus / mitmekesine",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Kas kasutad coachingtöös videot?",
          options: [
            {
              label: "Harva",
              score: 0,
            },
            {
              label: "Mõnikord (käsitsi)",
              score: 2,
            },
            {
              label: "Tihti — süstemaatiliselt",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Kas juhendad võistlusratsutajaid?",
          options: [
            {
              label: "Ei, harrastajaid",
              score: 0,
            },
            {
              label: "Mõnikord võistlusi",
              score: 2,
            },
            {
              label: "Palju — startkaardid on kesksel kohal",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Kas soovid oma coachingtöid mõõta?",
          options: [
            {
              label: "Ei, intuitsioon piisab",
              score: 0,
            },
            {
              label: "Küll, aga aega pole",
              score: 2,
            },
            {
              label: "Jah — andmepõhine coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Lihtne tööriist või isegi WhatsApp piisab — praegu.",
          body: "Vähem kui 5 ratsutaja puhul, kus videot ja võistlusi on vähe, on coachingrakendusse investeerimine ennatlik. EquiSight alustab tasuta, nii et saad seda proovida, kui sinu praktika kasvab.",
          cta: "Alusta tasuta",
        },
        mid: {
          title: "EquiSight Treener muudab sind süstemaatiliselt efektiivsemaks.",
          body: "5–15 kombinatsiooniga kaotad kuus tunde WhatsAppi ja eraldi videote peale. EquiSight koondab kõik kokku, skannib protokolle automaatselt ja tagab, et ratsutajad näevad oma tagasisidet alati uuesti.",
          cta: "Proovi treenerimoodulit",
        },
        high: {
          title: "EquiSight on loodud sinu coaching-mastaabile.",
          body: "Palju ratsutajaid, videot, võistlusi ja andmepõhist coachingut: just siin eristub EquiSight. EPI + protokolli skannimine + hobusedossieer annab sulle eelise, mida konkurentidel pole.",
          cta: "Planeeri demo oma coaching-praktika jaoks",
        },
      },
    },
    faqTitle: "Korduma kippuvad küsimused treenerirakenduste kohta",
    faq: [
      {
        q: "Milline on parim treenerirakendus hobusele ja ratsutajale?",
        a: "Puhta suhtluse jaoks sobivad paljud tööriistad (isegi WhatsApp). Eesmärkide, videoanalüüsi, protokolli skannimise, võistluste jälgimise ja kliendihalduse jaoks ühes tööriistas on EquiSight kõige terviklikum lahendus — eriti seetõttu, et see jälgib ka hobust ennast, mitte ainult kombinatsiooni.",
      },
      {
        q: "Kas EquiSight suudab võistlusprotokollid automaatselt lugeda?",
        a: "Jah. Laadi üles KNHS- või FEI-protokoll ja EquiSight eraldab tulemused osa kaupa, žürii kommentaarid ning seob need kombinatsiooniga. Trende näed mitme võistluse lõikes.",
      },
      {
        q: "Mis on EPI (Equestrian Performance Index)?",
        a: "EPI on EquiSight'i skoor, mis teisendab mitu võistlustulemust võrreldavaks sooritusindeksiks. Nii näed tõelist edasiminekut erinevate klasside ja žüriide lõikes.",
      },
      {
        q: "Kas ratsutajad saavad ise tunde broneerida ja maksta?",
        a: "Jah. Ratsutajad logitavad sisse, näevad saadavaid tunniaegesid, ostavad tunnikaarte ja maksavad iDEALiga. Sina otsustad, mida soovid pakkuda.",
      },
      {
        q: "Kas see toimib ka maneeži ümber töötava instrukori jaoks?",
        a: "Jah. Saad töötada vabakutselise treenerina oma klientidega ilma maneeži kontot sidumata. Kliendid maksavad sulle otse.",
      },
      {
        q: "Kas saan olemasolevad videod ja märkmed üle kanda?",
        a: "Videod saad laadida üles kombinatsiooni kaupa või partii-üleslaadimise tööriistaga. Märkmeid saab importida CSV kaudu. Aitame aktiivseid treenereid ühekordse migratsiooniga.",
      },
    ],
  },
  ui: {
    sectionEyebrows: {
      pains: "Miks see valutab",
      basics: "Põhitõed",
      criteria: "Mis teeb selle heaks?",
      comparison: "Aus võrdlus",
      why: "Erinevus",
      beforeAfter: "Killustatusest ülevaateni",
      helper: "5 küsimust",
    },
    table: {
      feature: "Funktsioon",
      today: "Täna",
      withEquisight: "EquiSight'iga",
    },
    helper: {
      questionLabel: "Küsimus {{current}} / {{total}}",
      answerPrompt: "Soovituse nägemiseks vasta {{count}} järelejäänud küsimusele.",
      answerPromptPlural: "Soovituse nägemiseks vasta {{count}} järelejäänud küsimusele.",
      resultEyebrow: "Sinu tulemus",
    },
    targetGroupsFallback: "Kellele see on mõeldud?",
    faqTitleFallback: "Korduma kippuvad küsimused",
  },
  gidsen: {
    seo: {
      title: "Gidsen & keuzehulpen voor paardenbeheer software | EquiSight",
      description: "Alle EquiSight gidsen op één plek: paardenbeheer, fokkerij, manege en trainer software vergelijkingen plus keuzehulpen voor 2026.",
      keywords: [
        "paardensoftware gidsen",
        "paardenbeheer keuzehulp",
        "fokkerij software vergelijken",
        "manege software gids",
        "trainer app vergelijking",
      ],
    },
    hub: {
      eyebrow: "Hub · gidsen",
      breadcrumbLabel: "Gidsen",
      title: "Vier complete gidsen om de juiste paardensoftware te kiezen.",
      intro: "Voor iedere doelgroep een diepgaande keuzehulp: vergelijkingstabellen, criteria, voorbeelden en interactieve quiz. Klik door naar de gids die past bij jouw situatie, of verken eerst de verdiepende artikelen onder elke cluster.",
      stats: {
        guides: "4 keuzehulpen",
        articles: "15 verdiepende artikelen",
        fair: "Eerlijke vergelijking",
      },
      readMoreCta: "Lees de complete gids",
      relatedHeading: "Verdiepende artikelen",
      articlesCountSingular: "{{count}} verdiepend artikel",
      articlesCountPlural: "{{count}} verdiepende artikelen",
      articlesCountAria: "Aantal cluster-artikelen",
      lastUpdatedPrefix: "Bijgewerkt",
      lastUpdatedAria: "Datum laatste update van deze cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Paardenbeheer app keuzehulp",
        blurb: "Vergelijk de bekendste paardenbeheer apps en ontdek welke past bij eigenaar, stal of fokkerij. Inclusief eerlijke vergelijkingstabel en 5-vragen keuzehulp.",
        audience: "Voor eigenaren, stalhouders en alle paardenmensen die overzicht zoeken.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Fokkerij software vergelijking",
        blurb: "Van merriecyclus tot veulenontwikkeling: bekijk welke fokkerij software echt werkt voor jouw aantal merries, fokmethode en stamboek-eisen.",
        audience: "Voor (hobby)fokkers, stoeterijen en hengstenhouders.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Manege software keuzehulp",
        blurb: "Lesplanning, ruiteradministratie, eigenaarsportaal en facturatie — in één tool. Vergelijk de opties voor maneges en pensionstallen in 2026.",
        audience: "Voor maneges, pensionstallen en rij-bedrijven.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trainer app keuzehulp",
        blurb: "Coaching-CRM, video-feedback, KNHS-protocol scannen en doelen per combinatie. Welke trainer app past bij jouw coaching praktijk?",
        audience: "Voor instructeurs, trainers en coaches.",
      },
    ],
    closing: {
      eyebrow: "Waarom deze gidsen",
      title: "Eerlijk vergelijken, niet alleen prijzen.",
      body1: "Veel \"vergelijkingspagina's\" zijn verkapte advertenties. Onze gidsen zetten functies, doelgroep en concurrenten naast elkaar zoals een onafhankelijke kennisbron dat zou doen. EquiSight komt natuurlijk naar voren als complete oplossing, maar je leest ook eerlijk waar andere apps sterker zijn.",
      body2: "De verdiepende artikelen onder elke gids beantwoorden de concrete vragen die voortkomen uit de keuze: \"Wanneer eerste echo na inseminatie\", \"Hoe automatiseer ik manege facturatie\", \"Hoe analyseer ik een wedstrijdprotocol\". Geen marketingfluff, wel praktijk.",
    },
    hubName: "EquiSight Gidsen",
  },
};

export default CORNERSTONES;
